// Subset of RMA Type Codes for LRP derived from RMA ADM A00540
export const RmaLrpTypeCodes = {
  // Feeder Cattle Types
  STEERS_WEIGHT_1: '809',
  STEERS_WEIGHT_2: '810',
  HEIFERS_WEIGHT_1: '811',
  HEIFERS_WEIGHT_2: '812',
  BRAHMAN_WEIGHT_1: '813',
  BRAHMAN_WEIGHT_2: '814',
  DAIRY_WEIGHT_1: '815',
  DAIRY_WEIGHT_2: '816',
  UNBORN_BULLS_AND_HEIFERS: '817',
  UNBORN_BRAHMAN: '818',
  UNBORN_DAIRY: '819',
  UNBORN_CALVES: '823',
  // Fed Cattle Types
  STEERS_AND_HEIFERS: '820',
  CULL_COWS: '821',
  // Swine Types
  UNBORN_SWINE: '821',
  NO_TYPE_SPECIFIED: '997',
} as const;

export type RmaLrpTypeCode =
  (typeof RmaLrpTypeCodes)[keyof typeof RmaLrpTypeCodes];

export function isRmaLrpTypeCode(typeCode: string): typeCode is RmaLrpTypeCode {
  return Object.values(RmaLrpTypeCodes).includes(typeCode as RmaLrpTypeCode);
}

/**
 * NOTE: These names do not match the RMA type names from ADM A00540.
 */
export const HiqLrpTypeCodeNames = {
  // Feeder Cattle
  STEERS_LIGHT: 'Steers, <600 lbs',
  STEERS: 'Steers, 600-1000 lbs',
  HEIFERS_LIGHT: 'Heifers, <600 lbs',
  HEIFERS: 'Heifers, 600-1000 lbs',
  BRAHMAN_LIGHT: 'Brahman, <600 lbs',
  BRAHMAN: 'Brahman, 600-1000 lbs',
  DAIRY_LIGHT: 'Dairy, <600 lbs',
  DAIRY: 'Dairy, 600-1000 lbs',
  UNBORN_BULLS_AND_HEIFERS: 'Unborn Bulls & Heifers',
  UNBORN_BRAHMAN: 'Unborn Brahman',
  UNBORN_DAIRY: 'Unborn Dairy',
  UNBORN_CALVES: 'Unborn Calves',
  // Fed Cattle
  STEERS_HEIFERS: 'Steers & Heifers',
  CULL_COWS: 'Cull Cows',
  // Swine
  UNBORN_SWINE: 'Unborn Swine',
  UNKNOWN: 'No Type Specified',
} as const;

export type HiqLrpTypeCodeNames =
  (typeof HiqLrpTypeCodeNames)[keyof typeof HiqLrpTypeCodeNames];

/**
 * @deprecated we should really know the type code everywhere we know the name
 */
export const LrpTypeCodeByName = {
  // Feeder Cattle
  [HiqLrpTypeCodeNames.STEERS_LIGHT]: RmaLrpTypeCodes.STEERS_WEIGHT_1,
  [HiqLrpTypeCodeNames.STEERS]: RmaLrpTypeCodes.STEERS_WEIGHT_2,
  [HiqLrpTypeCodeNames.HEIFERS_LIGHT]: RmaLrpTypeCodes.HEIFERS_WEIGHT_1,
  [HiqLrpTypeCodeNames.HEIFERS]: RmaLrpTypeCodes.HEIFERS_WEIGHT_2,
  [HiqLrpTypeCodeNames.BRAHMAN_LIGHT]: RmaLrpTypeCodes.BRAHMAN_WEIGHT_1,
  [HiqLrpTypeCodeNames.BRAHMAN]: RmaLrpTypeCodes.BRAHMAN_WEIGHT_2,
  [HiqLrpTypeCodeNames.DAIRY_LIGHT]: RmaLrpTypeCodes.DAIRY_WEIGHT_1,
  [HiqLrpTypeCodeNames.DAIRY]: RmaLrpTypeCodes.DAIRY_WEIGHT_2,
  [HiqLrpTypeCodeNames.UNBORN_BULLS_AND_HEIFERS]:
    RmaLrpTypeCodes.UNBORN_BULLS_AND_HEIFERS,
  [HiqLrpTypeCodeNames.UNBORN_BRAHMAN]: RmaLrpTypeCodes.UNBORN_BRAHMAN,
  [HiqLrpTypeCodeNames.UNBORN_DAIRY]: RmaLrpTypeCodes.UNBORN_DAIRY,
  [HiqLrpTypeCodeNames.UNBORN_CALVES]: RmaLrpTypeCodes.UNBORN_CALVES,
  // Fed Cattle
  [HiqLrpTypeCodeNames.STEERS_HEIFERS]: RmaLrpTypeCodes.STEERS_AND_HEIFERS,
  [HiqLrpTypeCodeNames.CULL_COWS]: RmaLrpTypeCodes.CULL_COWS,
  // Swine
  [HiqLrpTypeCodeNames.UNBORN_SWINE]: RmaLrpTypeCodes.UNBORN_SWINE,
  [HiqLrpTypeCodeNames.UNKNOWN]: RmaLrpTypeCodes.NO_TYPE_SPECIFIED,
};

export const RmaLrpTypeCodeNames = {
  STEERS_WEIGHT_1: 'Steers Weight 1',
  STEERS_WEIGHT_2: 'Steers Weight 2',
  HEIFERS_WEIGHT_1: 'Heifers Weight 1',
  HEIFERS_WEIGHT_2: 'Heifers Weight 2',
  BRAHMAN_WEIGHT_1: 'Brahman Weight 1',
  BRAHMAN_WEIGHT_2: 'Brahman Weight 2',
  DAIRY_WEIGHT_1: 'Dairy Weight 1',
  DAIRY_WEIGHT_2: 'Dairy Weight 2',
  UNBORN_BULLS_AND_HEIFERS: 'Unborn Bulls & Heifers',
  UNBORN_BRAHMAN: 'Unborn Brahman',
  UNBORN_DAIRY: 'Unborn Dairy',
  UNBORN_CALVES: 'Unborn Calves',
  STEERS_AND_HEIFERS: 'Steers & Heifers',
  CULL_COWS: 'Cull Cows',
  UNBORN_SWINE: 'Unborn Swine',
  NO_TYPE_SPECIFIED: 'No Type Specified',
} as const;

export type RmaLrpTypeCodeName =
  (typeof RmaLrpTypeCodeNames)[keyof typeof RmaLrpTypeCodeNames];
